class MainSlider {
  constructor () {
    this.initVarible();
    this.load();
  }

  initVarible () {
    this.mainSlider = null;
    this.pagination = {};
    this.autoplay = {};
    this.timer = null;
    this.isutoPlay = true;
    this.headerHeight = document.querySelector("header.header").clientHeight;
    this.getPagination();
    this.getAutoplay();
    const elementRect = document.querySelector(".js-main-slider .slideshow__media");
    const rect = elementRect.getBoundingClientRect();
  }

  load () {
    this.initSliders();
  }

  initSliders () {
    this.initMainSlider();
    this.scrollVideo();
    // window.addEventListener("resize", () => {
    //   if (this.timer) clearTimeout(this.timer);
    //   this.timer = setTimeout(() => this.resizeMainSlider(), 1000);
    // });
  }

  resizeMainSlider () {
    this.mainSlider.destroy(true, true);
    this.initMainSlider();
  }

  getPaginationPoints () {
    return {
      pagination: {
        el: document.querySelector(".js-slideshow-bullets"),
        type: "bullets",
        clickable: true,
        bulletActiveClass: "slideshow-dots__item--active",
        bulletClass: "slideshow-dots__item",
        renderBullet: function (index, className) {
          return "<span class=\"" + className + "\" ><span class=\"slideshow-dots__dot\">" + "</span></span>";
        }
      }
    };
  }

  getPaginationNumbers () {
    return {
      pagination: {
        el: document.querySelector(".js-slideshow-bullets"),
        type: "bullets",
        clickable: true,
        bulletActiveClass: "slideshow-numbers__item--active",
        bulletClass: "slideshow-numbers__item",
        renderBullet: function (index, className) {
          return "<span class=\"" + className + "\">" + (index + 1) + "</span>";
        }
      }
    };
  }

  getPaginationCounter () {
    return {
      on: {
        slideChange (slide) {
          document.querySelector(".slideshow-counter__slide").innerText = slide.activeIndex + 1;
        }
      }
    };
  }

  getPagination () {
    const pagination = document.querySelector(".js-main-slider").dataset.pagination;
    switch (pagination) {
      case "dots":
        this.pagination = this.getPaginationPoints();
        break;
      case "numbers":
        this.pagination = this.getPaginationNumbers();
        break;
      case "counter":
        this.pagination = this.getPaginationCounter();
        break;
    }
  }

  getAutoplay () {
    const dataSet = document.querySelector(".js-main-slider").dataset;
    const { autorotate, delay } = dataSet;
    if (autorotate == "true") {
      this.autoplay = {
        autoplay: {
          delay: delay ? delay * 1000 : 5000
        }
      };
    }
  }

  scrollVideo () {
    document.addEventListener("scroll", () => {
      if(this.mainSlider) this.checkIsVisible();
    });
  }

  checkIsVisible () {
    const elementRect = document.querySelector(".js-main-slider .slideshow__media");
    const rect = elementRect.getBoundingClientRect();

    const isVisible = (rect.top + rect.height - this.headerHeight >= 0);
    if (isVisible && !this.isutoPlay) {
      this.isutoPlay = true;
      this.mainSlider.autoplay.resume();
      this.mainSlider.autoplay.start();
      // console.log("turn on");
    }
    if (!isVisible && this.isutoPlay) {
      this.mainSlider.autoplay.pause();
      this.mainSlider.autoplay.stop();
      this.isutoPlay = false;
      // console.log("turn off");
    }
  }

  async initMainSlider () {
    if (this.mainSlider !== null) return;
    const _this = this;


    const myPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.pagination);
      }, 0);
    });

    myPromise.then((pagination) => {
      this.mainSlider = new Swiper(".js-main-slider", {
        ...this.autoplay,
        slidesPerView: 1,
        loop: true,
        autoHeight: true,
        on: {
          realIndexChange (swiperSlides) {
           // console.log('slideChange slideshow' )
          },
          afterInit () {
            setTimeout(() => {
              _this.checkIsVisible();
            }, 100);

          }
        },
        lazy: {
          loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
          loadPrevNextAmount: 1 //or, if you wish, preload the next 2 images
        },
        ...pagination
      });
    });
  }

  static initHandlers () {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        new MainSlider();
      }, 0);
    });
  }
}

MainSlider.initHandlers();
